import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DDOption from '../models/DropdownModels';
import axios from 'axios';
import { getStorageValues } from '../CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';


function StatusDropdown({ onChangeDropdown, required, showLabel,isDisable, selectedValue }) {
    const [selectedStatusOption, setSelectedStatusOption] = useState([]);
    const [getStatusOptions, setStatusOptions] = useState([]);
    let labelHtml;
    if(showLabel === undefined){
        labelHtml = 
            <label className="form-label">
                Status { required === true ? <span style={{ color: "red" }}>*</span> : "" }
            </label>
    } else {    
        if(showLabel === true){
            labelHtml = 
                <label className="form-label">
                    Status { required === true ? <span style={{ color: "red" }}>*</span> : "" }
                </label>
        } 
    }

    function handleChange(e, actionMeta) {
        setSelectedStatusOption(e);
        onChangeDropdown(e, actionMeta);
    };

    const fetchStatus = async () => {
        try {
            let statusDetails = {
                UserId: getStorageValues('userId')
            };
            const response = await axios.get(getApiBaseUrl() + "/statuslist", {params: statusDetails});
            if (response.status === 200) {
                setStatusDropdownData(response.data.data[0]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    function setStatusDropdownData(cct) {
        let allModuleOpt = [];
        allModuleOpt = cct.map(p => ({ value: p.StatusId, label: p.StatusName, name: 'Status', description: p.Discription, isFixed: false, isDisabled: false, groupId: null }))
        setStatusOptions(allModuleOpt);
        if(selectedValue !== undefined){
            setSelectedStatusOption(allModuleOpt.filter(x => x.value === selectedValue));
        } else {
            setSelectedStatusOption(allModuleOpt.filter(x=>x.label === "Needs Review"));
        }
        onChangeDropdown(allModuleOpt.filter(x=>x.label === "Needs Review")[0],{action:"select-option",name:"StatusId",option:undefined})
        
    }

    useEffect(() => {
        fetchStatus();
    }, []);
    return (
        <div className="col-12">
            <div className="mb-3">
                {labelHtml}
                <Select
                    name="StatusId"
                    value={selectedStatusOption ? selectedStatusOption : []}
                    isClearable={true}
                    isDisabled = {isDisable}
                    options={getStatusOptions || []}
                    onChange={handleChange}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })  // ensure it's above table
                    }}
                />
            </div>
        </div>
    )
}

export default StatusDropdown